module.exports = __webpack_public_path__ + "img/ordMatrixyl2.e11fd372.jpg";